import React from 'react'
import { Route, useParams, Link, useLocation } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'

import { Col, Layout, Row, Spin, Typography } from 'antd'

import './layout.css'

const HomeIndex = React.lazy(() => import('./Article/HomeIndex'))
const Article = React.lazy(() => import('./Article/Article.container'))

// 转换路由中的ID参数为number类型，同时路由中的(\\d+)正则匹配限定参数为数字
const ArticlewithRoute: React.FC = () => {
  const { articleID }: { articleID: string } = useParams()
  return <Article articleID={Number(articleID)} />
}

const Home: React.FC = () => {
  const isBig = useMediaQuery({ query: '(min-width: 780px)' })
  const isSmallMax = useMediaQuery({ query: '(max-width: 780px)' })
  const location = useLocation()
  return (
    <Layout>
      <Layout.Header style={{ padding: isBig ? '0px 50px' : '0px 15px 0px 30px' }}>
        <Row gutter={24}>
          <Col span={isBig ? 4 : 12}>
            <Link to="/">
              <img
                src="https://verticalmind-image-hosting-service.oss-cn-shanghai.aliyuncs.com/hzlogo.png"
                style={{
                  width: '150px',
                  height: '40px'
                }}
                alt="logo"
              />
            </Link>
          </Col>
        </Row>
      </Layout.Header>
      {/*64 70 30 分别代表 <header>的height、<footer>的height 以及 <content>的margin的值*/}
      <Layout.Content
        style={{
          margin: location.pathname.includes('/charts/') && !isBig ? '0px' : '16px',
          padding:
            location.pathname.includes('/charts/') && !isBig ? '0px' : isSmallMax ? '0px 10px 10px' : '0 50px 20px',
          border: '1px solid #red',
          background: '#fff'
        }}
      >
        <React.Suspense
          fallback={
            <div style={{ margin: '50% auto', textAlign: 'center' }}>
              <Spin />
            </div>
          }
        >
          <Route key={'home'} exact path={'/'} component={HomeIndex} />
          <Route key={'article'} exact path={'/articles/:articleID(\\d+)'} component={ArticlewithRoute} />
        </React.Suspense>
      </Layout.Content>
      <Layout.Footer id="aboutUs" style={{ padding: isBig ? '24px 50px' : '24px 20px' }}>
        <Row gutter={24}>
          <Col span={isSmallMax ? 0 : 4} />
          <Col span={isSmallMax ? 24 : 16}>
            <Row gutter={24}>
              <Col span={isSmallMax ? 24 : 12}>
                {/*Team Info*/}
                <Typography.Title level={3} style={{ fontSize: isBig ? '24px' : '20px' }}>
                  Horizon Insights
                </Typography.Title>
                {/* <Typography.Paragraph style={{ textAlign: 'justify' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Config.homeIntroTeamParagraph}
                </Typography.Paragraph> */}
              </Col>

              {/*Company Info*/}
              <Col span={isSmallMax ? 24 : 12}>
                <Typography.Title level={3} style={{ fontSize: isBig ? '24px' : '20px' }}>
                  Horizon Insights (Shanghai)
                </Typography.Title>
                <Typography.Text>
                  <p>Address: 1201, Century Avenue No. 210, Pudong New District, Shanghai</p>
                  <p>Tel: 86-21-61645300</p>
                  <p>Contact：service@hzinsights.com</p>
                  <p>Website：http://www.hzinsights.com</p>
                </Typography.Text>
              </Col>

              {/*Declaration Info*/}
              <Col span={24}>
                <Typography.Title level={3} style={{ fontSize: isBig ? '24px' : '20px' }}>
                  Disclaimers
                </Typography.Title>
                <Typography.Paragraph style={{ textAlign: 'justify' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This report is to be used solely by the clients of Horizon
                  Insights (hereinafter referred to as the &quot;Company&quot;). The Company will not deem any other
                  person as its client notwithstanding his receipt of this report. Under no circumstances shall the
                  information contained herein or the opinions expressed herein form an investment recommendation to
                  anyone. Under no circumstances shall the Company be held responsible for any loss caused by the use of
                  any contents herein by anyone.
                </Typography.Paragraph>
              </Col>
            </Row>
          </Col>
          <Col span={isSmallMax ? 0 : 4} />
        </Row>
      </Layout.Footer>
    </Layout>
  )
}

export default Home
